var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 374,
    height: 149,
    viewBox: "0 0 374 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 374,
    height: 149,
    rx: 13,
    fill: "#F3F7FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299 0L360.975 0C368.155 0 373.975 5.8203 373.975 13V57.7465C371.998 57.9143 369.997 58 367.975 58C333.407 58 304.691 32.9425 299 0Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M339.456 27.2C341.552 27.2 342.784 25.952 342.784 24C342.784 22.048 341.552 20.8 339.456 20.8H335.552V32H336.96V27.2H339.456ZM339.536 25.856H336.96V22.144H339.536C340.688 22.144 341.328 22.816 341.328 24C341.328 25.184 340.688 25.856 339.536 25.856ZM344.646 20.8V32H347.718C350.47 32 352.87 30.032 352.87 26.4C352.87 22.768 350.47 20.8 347.718 20.8H344.646ZM347.478 22.144C349.542 22.144 351.366 23.264 351.366 26.4C351.366 29.536 349.542 30.656 347.478 30.656H346.054V22.144H347.478ZM354.943 20.8V32H356.351V26.832H360.495V25.488H356.351V22.144H361.455V20.8H354.943Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentPdf);
export default __webpack_public_path__ + "static/media/document_pdf.2e18878a8e8e564810c485312e58e03f.svg";
export { ForwardRef as ReactComponent };